import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const backgroundImageWidthType = PropTypes.oneOf([
  'Page width',
  'Edge-to-edge',
]);
